import { createContext, useContext } from 'react';
import type { Session } from '@supabase/supabase-js';

type SessionValue = {
  session: Session;
};

const SessionContext = createContext<SessionValue | null>(null);

export const SessionProvider = SessionContext.Provider;

export const useSession = () => {
  const value = useContext(SessionContext);
  if (!value) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return value.session;
};

